import type { PolicyId } from './types'

export const ECOM_POLICY_FILTER_QUERY_KEY = 'ecom-policy-filter'
export const TELE_POLICY_FILTER_QUERY_KEY = 'tele-policy-filter'

export function serializeEcomPolicyFilterParam(policyIds: PolicyId[] | null): string | null {
  if (!policyIds || policyIds.length === 0) return null

  return policyIds.join(',')
}

export function parseEcomPolicyFilterParam(value: string | null): PolicyId[] | null {
  if (!value) return null

  const parsedPolicyIds = value
    .split(',')
    .map(item => parsePolicyId(item))
    .filter((item): item is PolicyId => item !== null)

  return parsedPolicyIds.length > 0 ? parsedPolicyIds : null
}

export function serializeTelePolicyFilterParam(policyIds: PolicyId[] | null): string | null {
  if (!policyIds || policyIds.length === 0) return null

  return String(policyIds[0])
}

export function parseTelePolicyFilterParam(value: string | null): PolicyId[] | null {
  const parsedPolicyId = parsePolicyId(value)

  return parsedPolicyId === null ? null : [parsedPolicyId]
}

function parsePolicyId(value: string | null): PolicyId | null {
  if (!value) return null
  if (value === 'no-policy') return value

  const parsedValue = Number(value)

  return Number.isInteger(parsedValue) ? parsedValue : null
}
